import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { queryKeys } from "@/rc/keys";
import { useAuth } from "@/contexts/AuthContext";
import { isSuperAdmin } from "@/lib/auth/roles";

export function useProfile() {
  const { user } = useAuth();
  const userId = user?.id;

  const query = useQuery({
    queryKey: queryKeys.user.profile(userId ?? "__none__"),
    enabled: Boolean(userId),
    queryFn: async () => {
      if (!userId) return null;
      const { data, error } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", userId)
        .single();
      if (error) throw error;
      return data;
    },
  });

  return {
    ...query,
    /** True only after a successful profile load — avoids treating unknown users as non-superadmin incorrectly after fetch errors. */
    isSuperAdmin: Boolean(query.isSuccess && isSuperAdmin(query.data)),
  };
}
